<!--
  UN solo buscador. Eran cinco cuadros de filtro por columna, descuadrados sobre las cabeceras, y
  varios ni siquiera filtraban: su campo no estaba declarado en el backend y la consulta los ignoraba
  en silencio. La pregunta de Operaciones es una: «encuéntrame este pago».
-->
<div class="pt-toolbar">
  <span class="p-input-icon-left pt-search">
    <i class="fa-solid fa-magnifying-glass"></i>
    <input
      pInputText
      type="text"
      [ngModel]="busqueda"
      (ngModelChange)="onBuscar($event)"
      placeholder="Buscar por cliente o clave de rastreo"
      aria-label="Buscar pagos"
    />
    <button type="button" class="pt-clear" *ngIf="busqueda" (click)="limpiarBusqueda()" aria-label="Limpiar la búsqueda">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </span>

  <span class="pt-count" *ngIf="!cargando && !isSearchStale">
    <b>{{ total }}</b> {{ total === 1 ? 'pago' : 'pagos' }}<ng-container *ngIf="shownSearch"> con «{{ shownSearch }}»</ng-container>
  </span>

  <!-- La lente de Operaciones: «enséñame lo que falta por aplicar». El número es de TODA la cartera,
       no de esta página, y por eso se pide aparte. -->
  <button
    type="button"
    class="pt-lente"
    [class.is-on]="soloPendientes"
    (click)="alternarPendientes()"
    [attr.aria-pressed]="soloPendientes"
    [pTooltip]="soloPendientes ? 'Quitar el filtro y ver todos los pagos' : 'Ver solo los pagos a los que les queda dinero por aplicar'"
    tooltipPosition="top"
  >
    <i class="fa-solid fa-hourglass-half"></i>
    <span>Pendientes de aplicar</span>
    <span class="pt-lente__n" *ngIf="pendientesTotal !== null">{{ pendientesTotal }}</span>
  </button>

  <!-- Las dos acciones que traía la tabla genérica y que no se pueden perder: registrar un pago a
       mano, y la exportación con la que Contabilidad cuadra el mes. -->
  <div class="pt-acciones">
    <button
      pButton
      type="button"
      label="Exportar"
      icon="fa-solid fa-file-excel"
      class="p-button-sm p-button-outlined"
      [loading]="exportando"
      (click)="exportar()"
    ></button>
    <button
      pButton
      type="button"
      label="Registrar pago"
      icon="fa-solid fa-square-plus"
      class="p-button-sm p-button-outlined"
      *appIfHasPermission="['payments', 'create']"
      (click)="registrar.emit()"
    ></button>
  </div>
</div>

<div class="pt-wrap">
  <table class="pt-table">
    <thead>
      <tr>
        <th class="pt-col-exp"></th>
        <th>Fecha de pago</th>
        <th>Cliente</th>
        <th>Clave de rastreo</th>
        <th class="ta-r">Monto</th>
        <th class="ta-r">Aplicado</th>
        <th class="ta-r">Sin aplicar</th>
        <th>Estado</th>
        <th class="pt-col-act"></th>
      </tr>
    </thead>

    <!-- El esqueleto tiene la geometría final: al llegar los datos nada salta de sitio. -->
    <tbody *ngIf="cargando || isSearchStale">
      <tr *ngFor="let s of esqueleto; let i = index" [ngClass]="'sk-fade-' + (i > 3 ? 4 : i + 1)" aria-hidden="true">
        <td><p-skeleton width="1.2rem" height="1.2rem" borderRadius="4px"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="5rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="7rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="10rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="5.5rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="5.5rem"></p-skeleton></td>
        <td><p-skeleton height="0.8rem" width="5.5rem"></p-skeleton></td>
        <td><p-skeleton height="1.3rem" width="5rem" borderRadius="6px"></p-skeleton></td>
        <td><p-skeleton height="1.7rem" width="4.5rem" borderRadius="6px"></p-skeleton></td>
      </tr>
    </tbody>

    <tbody *ngIf="!cargando && !isSearchStale">
      <ng-container *ngFor="let f of filas">
        <tr class="pt-row" [class.is-open]="estaAbierta(f)" [class.is-bad]="f.estado === 'atorado'">
          <td class="pt-col-exp">
            <button
              type="button"
              class="pt-exp"
              [class.is-open]="estaAbierta(f)"
              (click)="alternar(f)"
              [attr.aria-expanded]="estaAbierta(f)"
              [attr.aria-label]="'Detalle del pago ' + f.claveRastreo"
            >
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </td>
          <td class="pt-fecha">{{ f.fecha ? (f.fecha | date: 'dd/MM/yyyy' : 'UTC') : '—' }}</td>
          <td>
            <a *ngIf="f.clienteId; else soloNombre" class="link-subsection" [routerLink]="['/customer', f.clienteId]">{{ f.cliente }}</a>
            <ng-template #soloNombre>{{ f.cliente }}</ng-template>
          </td>
          <td class="pt-clave">{{ f.claveRastreo }}</td>
          <td class="ta-r pt-num">{{ f.monto | currency }}</td>
          <td class="ta-r pt-num">
            {{ f.aplicado | currency }}
            <!-- El desfase no se esconde detrás de una cifra bonita: si lo guardado y el libro no
                 coinciden, este pago necesita que alguien lo mire. -->
            <i
              class="fa-solid fa-triangle-exclamation pt-drift"
              *ngIf="f.desfase"
              pTooltip="Lo que el pago tiene guardado no coincide con su libro de aplicaciones"
              tooltipPosition="top"
            ></i>
          </td>
          <td class="ta-r pt-num" [class.is-pend]="f.sinAplicar > 0">{{ f.sinAplicar | currency }}</td>
          <td>
            <span class="pt-pill" [ngClass]="'is-' + estados[f.estado].tono">{{ estados[f.estado].label }}</span>
            <!-- La antigüedad es lo que convierte «sin aplicar» en un pendiente: un pago de ayer es
                 normal, uno de hace tres semanas es dinero del cliente parado. Solo aparece cuando ya
                 pasó del umbral, o dejaría de significar algo. -->
            <span
              class="pt-edad"
              *ngIf="diasEsperando(f) as dias"
              [pTooltip]="'Su dinero lleva ' + dias + ' días sin aplicarse. Se cuenta desde que el cliente pagó.'"
              tooltipPosition="top"
              >{{ dias }} d</span
            >
          </td>
          <!-- Solo mientras al pago le quede dinero sin repartir: sobre uno ya aplicado, anular no
               cancela sus aplicaciones y el motor lo bloquea. Ver `sePuedeAnular`. -->
          <td class="pt-col-act">
            <!-- Aplicar el dinero que falta repartir sin salir de Cobranza: el mismo diálogo y el mismo
                 motor que la pestaña Exigibilidad. Con desfase o atorado no se ofrece: primero hay que
                 sanearlo, y el motor trabaja con otra cifra que la que enseña la fila. -->
            <ng-container *appIfHasPermission="['applications', 'create']">
              <button
                *ngIf="sePuedeAplicar(f)"
                pButton
                type="button"
                label="Aplicar"
                icon="fa-solid fa-hand-holding-dollar"
                pTooltip="Repartir este dinero entre las letras del cliente"
                tooltipPosition="left"
                class="p-button-sm p-button-text pt-aplicar"
                (click)="aplicar.emit(f)"
              ></button>
            </ng-container>
            <ng-container *appIfHasPermission="['payments', 'adjust']">
              <button
                pButton
                type="button"
                icon="fa-solid fa-calendar-day"
                pTooltip="Corregir la fecha a la del depósito real"
                tooltipPosition="left"
                aria-label="Corregir fecha"
                class="p-button-sm p-button-text pt-fecha-btn"
                (click)="abrirFecha(f)"
              ></button>
              <!-- Corregir monto o clave (F-045). Se ofrece siempre: la clave se corrige con o sin
                   aplicaciones, y el diálogo explica por qué el monto no, cuando no se puede. -->
              <button
                pButton
                type="button"
                label="Editar"
                icon="fa-solid fa-pen-to-square"
                pTooltip="Corregir el monto o la clave de rastreo"
                tooltipPosition="left"
                class="p-button-sm p-button-text pt-edit"
                (click)="edit.emit(f)"
              ></button>
              <button
                *ngIf="sePuedeAnular(f)"
                pButton
                type="button"
                label="Anular"
                icon="fa-solid fa-ban"
                pTooltip="Sacar de circulación una carga repetida"
                tooltipPosition="left"
                class="p-button-sm p-button-text pt-anular"
                (click)="anular.emit(f)"
              ></button>
            </ng-container>
          </td>
        </tr>

        <!-- El detalle sale DEBAJO de su fila y la lista sigue ahí. Era un modal, y un modal tapa
             justo la lista de la que salió: comparar dos pagos era abrir, leer, cerrar y reabrir. -->
        <tr class="pt-detalle" *ngIf="estaAbierta(f)">
          <td colspan="9">
            <div class="pt-det-carga" *ngIf="f.cargandoDetalle">
              <i class="fa-solid fa-spinner fa-spin"></i> Cargando el detalle del pago…
            </div>

            <div class="pt-det" *ngIf="!f.cargandoDetalle && f.detalle">
              <section>
                <h4>A dónde fue el dinero</h4>

                <p class="pt-det-vacio is-error" *ngIf="f.detailFailed">
                  <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i> No se pudo cargar a dónde fue el dinero. Cierra y
                  vuelve a desplegar la fila.
                </p>

                <p class="pt-det-vacio" *ngIf="!f.detailFailed && !f.detalle.aplicaciones.length">
                  No se ha aplicado a ningún arrendamiento. Sigue disponible por <b>{{ f.sinAplicar | currency }}</b
                  >.
                </p>

                <!-- Con encabezado y columnas de ancho fijo a la derecha. Sin él, la fecha y el
                     importe salían flotando al final de un hueco enorme —la columna del destino se
                     comía el sobrante— y nada decía qué eran esos dos números. -->
                <div class="pt-det-tabla" *ngIf="f.detalle.aplicaciones.length">
                  <div class="pt-det-th">
                    <span>Arrendamiento</span>
                    <span>A qué se aplicó</span>
                    <span class="ta-r">Fecha</span>
                    <span class="ta-r">Monto</span>
                  </div>

                  <ul class="pt-det-lista">
                    <li *ngFor="let a of f.detalle.aplicaciones">
                      <!-- Directo a Exigibilidad: quien viene de un pago quiere el libro mayor donde ese
                           dinero cayó, no los datos del cliente. -->
                      <a
                        *ngIf="a.leaseId; else soloFolio"
                        class="link-subsection"
                        [routerLink]="['/lease', a.leaseId]"
                        [queryParams]="{ tab: 'exigibilidad' }"
                        >{{ a.folio || 'Ver arrendamiento' }}</a
                      >
                      <ng-template #soloFolio
                        ><span>{{ a.folio || '—' }}</span></ng-template
                      >
                      <em>{{ destino(a) }}</em>
                      <span class="pt-det-fecha ta-r">{{ a.fecha | date: 'dd/MM/yyyy' : 'UTC' }}</span>
                      <b class="ta-r">{{ a.monto | currency }}</b>
                      <!-- F-045 · La acción vive en el renglón de SU aplicación, en una línea propia: en la
                           mitad del detalle no cabe como quinta columna sin cortar el folio. Desde Dinero es
                           la única forma de deshacer un pago ya repartido —«Anular» no cancela aplicaciones—. -->
                      <ng-container *appIfHasPermission="['applications', 'delete']">
                        <div class="pt-det-action" *ngIf="canCancelApplication(a)">
                          <button
                            pButton
                            type="button"
                            label="Cancelar aplicación"
                            icon="fa-solid fa-ban"
                            class="p-button-text p-button-sm pt-cancel-application"
                            (click)="requestCancelApplication(f, a)"
                          ></button>
                        </div>
                      </ng-container>
                    </li>
                  </ul>
                </div>
              </section>

              <section>
                <h4>Comprobantes</h4>

                <p class="pt-det-vacio" *ngIf="!f.detalle.facturas.length">Este pago no tiene facturas asociadas.</p>

                <div class="pt-det-tabla" *ngIf="f.detalle.facturas.length">
                  <div class="pt-det-th">
                    <span>Folio fiscal</span>
                    <span>Concepto</span>
                    <span class="ta-r">Emitida</span>
                    <span class="ta-r">Monto</span>
                  </div>

                  <ul class="pt-det-lista">
                    <li *ngFor="let inv of f.detalle.facturas">
                      <span class="pt-uid">{{ inv.folioFiscal || inv.uid }}</span>
                      <em>{{ conceptoLabel(inv.concept) }}</em>
                      <span class="pt-det-fecha ta-r">{{ inv.issueDate | date: 'dd/MM/yyyy' : 'UTC' }}</span>
                      <b class="ta-r">{{ inv.amount | currency }}</b>
                    </li>
                  </ul>
                </div>
              </section>
            </div>
          </td>
        </tr>
      </ng-container>

      <tr *ngIf="!filas.length">
        <td colspan="9" class="pt-vacio">
          <ng-container *ngIf="shownSearch; else sinNada">
            Ningún pago coincide con «{{ shownSearch }}».
            <button type="button" class="pt-link" (click)="limpiarBusqueda()">Limpiar la búsqueda</button>
          </ng-container>
          <ng-template #sinNada>Todavía no hay pagos registrados.</ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Siempre que haya filas, no solo cuando sobra una página: aquí vive el selector de 30/60/90 y
     esconderlo deja al operador sin forma de pedir más. -->
<p-paginator
  *ngIf="!cargando && !isSearchStale && total"
  [first]="pagina * porPagina"
  [rows]="porPagina"
  [totalRecords]="total"
  [rowsPerPageOptions]="opcionesPagina"
  (onPageChange)="onPagina($event)"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} pagos"
  [showCurrentPageReport]="true"
></p-paginator>

<!-- Corregir la fecha vive con la tabla: no depende de la pantalla que la aloja y recarga lo suyo. -->
<app-payment-date-dialog [(visible)]="fechaVisible" [payment]="fechaPago" (saved)="recargar()"></app-payment-date-dialog>
